import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';

export interface IntermediaryInitialValues {
  isPreRegistration: boolean | undefined;
  hasCadastroData: boolean | undefined;
  loadedPrevRegistration: boolean | undefined;
  mode: {new: boolean; edit: boolean; detail: boolean};
  isNonResident: boolean | undefined;
  preFilledForm: object | undefined;
}

export const INITIAL_VALUES = new InjectionToken<IntermediaryInitialValues>('initial.values');

export const FIXED_VALUES_OBS = new InjectionToken<Observable<IntermediaryInitialValues | undefined>>('FIXED_VALUES_OBS');

export const ROUTER_BASE_PATH = new InjectionToken<string>('ROUTER_BASE_PATH');
